import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {

    get(key: string): any {
         if (!key) {
             return;
        }
        return JSON.parse(window.localStorage.getItem(key));
    }

    set(key: string, data: any) {
        if (!key || !data) {
             return;
        }

        window.localStorage.setItem(key, JSON.stringify(data));
    }

    remove(key: string) {
        if (!key) {
             return;
        }

        window.localStorage.removeItem(key);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/services/local-storage.service.ts